import axios from "axios";

const getRoles = async () => {
  const baseUrl = process.env.REACT_APP_API_URL;

  try {
    const response = await axios.get(`${baseUrl}/api/role/`);
    return response.data;
  } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message);
    } else {
      throw new Error("Terjadi kesalahan saat login");
    }
  }
};

const createRole = async (payload) => {
  const baseUrl = process.env.REACT_APP_API_URL;
  try {
    const response = await axios.post(
      `${baseUrl}/api/roles/permission/user`,
      payload
    );
    return response.data;
  } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message);
    } else {
      throw new Error("Terjadi kesalahan saat submit");
    }
  }
};

const updateRole = async (payload) => {
  const baseUrl = process.env.REACT_APP_API_URL;
  try {
    const response = await axios.post(
      `${baseUrl}/api/roles/permission/user/update`,
      payload
    );
    return response.data;
  } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message);
    } else {
      throw new Error("Terjadi kesalahan saat submit");
    }
  }
};

const deleteRole = async (body) => {
  const baseUrl = process.env.REACT_APP_API_URL;
  try {
    const res = await axios.post(`${baseUrl}/api/roles/permission/user/delete`, body);
    return res.data;
  } catch (error) {
    if (error.response?.data?.message) {
      throw new Error(error.response.data.message);
    } else {
      throw new Error("Terjadi kesalahan saat hapus data");
    }
  }
};

const dropdownRoles = async () => {
  const baseUrl = process.env.REACT_APP_API_URL;

  try {
    const response = await axios.get(`${baseUrl}/api/role/drop/down`);
    return response.data;
  } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message);
    } else {
      throw new Error("Terjadi kesalahan saat login");
    }
  }
};

export {
  getRoles,
  createRole,
  updateRole,
  deleteRole,
  dropdownRoles
};
